export function Sealed() {
    return (target) => {
        Object.seal(target);
        return target;
    };
}
//# sourceMappingURL=sealed.js.map